import React from 'react';
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import './ArticlePullQuote.scss';

export interface ArticlePullQuoteInputs {
    text: string;
    author: string;
    image?: ImageDataLike;
    alt?: string;
}

export const ArticlePullQuote = ({
    inputs,
}: {
    inputs: ArticlePullQuoteInputs;
}) => {
    return (
        <div className="pull-quote">
            {inputs.image && (
                <GatsbyImage image={getImage(inputs.image)} alt={inputs.alt} />
            )}
            <div className="pull-quote__text">
                <blockquote>
                    <div
                        id="content"
                        dangerouslySetInnerHTML={{
                            __html: inputs.text,
                        }}
                    />
                    <cite>
                        <div className="author-decorator" />
                        <span className="typestack-body-2">
                            {inputs.author}
                        </span>
                    </cite>
                </blockquote>
            </div>
        </div>
    );
};
